import './footer-mobile.scss';
import { PAGE_MOBILE } from "@/lib/constants";
import { ProjectModel } from '@/lib/models/Project';
import { SetAudioMute } from '@/lib/utils/Audio';

interface Props {
  footerType: number;
  footerColor: string | void;
  handlePrevStep: () => void;
  handleNextStep: () => void;
  onViewWork: () => void;
  listProject: ProjectModel[];
  hideBorder?: boolean;
  hideContent?: boolean;
  hideText?: boolean;
}

const FooterMobile = (props: Props) => {
  const { footerType, footerColor, handlePrevStep, handleNextStep, onViewWork, listProject, hideBorder, hideContent, hideText } = props;

  const _renderFooterTitle = () => {
    return (
      <>
        <div className='footer-mobile-border' style={{ borderColor: 'transparent' }}></div>
        <div className={'footer-mobile-container footer-mobile-container--nav'}>
          <div className='footer-nav-bar'>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handlePrevStep}
            >
              CONTACT US
            </button>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handleNextStep}
            >
              NEXT
            </button>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterIntro = () => {
    return (
      <>
        <div className='footer-mobile-border'></div>
        <div className={'footer-mobile-container footer-mobile-container--nav'}>
          <div className='footer-nav-bar'>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handlePrevStep}
            >
              BACK
            </button>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handleNextStep}
            >
              NEXT
            </button>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterLoading = () => {
    SetAudioMute('.audio-icon', '.video-container video', true);
    return (
      <>
        <div className='footer-mobile-border'></div>
        <div className={'footer-mobile-container footer-mobile-container--nav'}>
          <div className='footer-nav-bar'>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handlePrevStep}
            >
              BACK
            </button>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handleNextStep}
            >
              NEXT
            </button>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterProject = () => {
    return (
      <>
        <div className='footer-mobile-border' style={{ borderColor: 'transparent' }}></div>
        <div className='footer-mobile-gradient' />
        <div
          className={'footer-mobile-container footer-mobile-container--stacked'}
          style={{ "--footer-color": footerColor } as React.CSSProperties}
        >
          <button
            type='button'
            className='footer-view-button letter-scrambler'
            onClick={onViewWork}
          >
            VIEW THE WORK
          </button>
          <div className='footer-nav-bar'>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handlePrevStep}
            >
              BACK
            </button>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handleNextStep}
            >
              NEXT
            </button>
          </div>
        </div>
      </>
    )
  };

  const _renderFooterReach = () => {
    return (
      <>
        <div className='footer-mobile-border'></div>
        <div className={'footer-mobile-container footer-mobile-container--nav'}>
          <div className='footer-nav-bar'>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handlePrevStep}
            >
              BACK
            </button>
            <button
              type='button'
              className='footer-nav-button'
              onClick={handleNextStep}
            >
              NEXT
            </button>
          </div>
        </div>
      </>
    )
  }

  const _renderFooter = () => {
    switch (footerType) {
      case PAGE_MOBILE.TITLE:
        return _renderFooterTitle();
      case PAGE_MOBILE.LOADING:
        return _renderFooterLoading();
      case PAGE_MOBILE.INTRO:
        return _renderFooterIntro();
      case PAGE_MOBILE.REACH + listProject.length - 1:
        return _renderFooterReach();
      default:
        return _renderFooterProject();
    }
  };

  return (
    <div className={`footer-mobile ${hideBorder ? 'footer-mobile--border-hidden' : ''} ${hideContent ? 'footer-mobile--content-hidden' : ''} ${hideText ? 'footer-mobile--text-hidden' : ''}`}>
      {_renderFooter()}
    </div>
  )

};

export default FooterMobile;
